import * as utils from './utils.js';
import * as canvasRender from './canvas-render.js';
import config from './config.js';
import * as validation from './validation.js';
import * as ui from './ui.js';
import * as log from './log.js';
import * as googleevents from './google-events.js';
import * as cropperhandler from './cropper-handler.js';
import * as apihandler from './api-handler.js';

const postShare = document.querySelector(".postshare");
const imageDesigned = document.querySelector(".image-designed");
const boxImage = document.querySelector('.box-image');
const downloadImageDiv = document.querySelector(".download-image");
const messageDiv = document.querySelector(".message");
const downloadTPhoneDiv = document.querySelector(".download-T-Phone");
// result-title
const resultTitle = document.querySelector(".result-title");

const imageContainer = document.querySelector(".images-container");
const rowContainer = document.querySelector(".multi-images");
const fbSharedDiv = document.querySelector(".fb-shared");
const adsElements = document.querySelectorAll(".adsClass");
const titleInput = document.getElementById("title");
const videoContainer = document.querySelector(".videocontainer");
const fbMessenger = document.querySelector(".fb-messenge");
const fbLinkMessenger = document.querySelector('.fblink-mesenger');
const messageList = document.querySelector('.message-list');
const contactForm = document.getElementById('contactForm');
const historyContainer = document.getElementById("historyContainer");
/**
 * events of the form
 */
/**
 * 
 * @param {object} settingData 
 */
export function callEvents(settingData) {
  const fbsharelink = document.getElementById("fbsharelink");
  if (fbsharelink) {
    fbsharelink.addEventListener("click", function (e) {
      e.preventDefault();
      const sharedLink = this.getAttribute("href");
      FB.ui(
        {
          method: "feed",
          href: sharedLink,
          link: sharedLink,
        },
        function (response) { }
      );
    });
  }

  const notification = document.querySelector(".notification");
  if (notification) {
    notification.addEventListener("click", function (e) {
      if (e.target.classList.contains("no-notify")) {
        const modal = document.getElementById("exampleModal");
        if (modal) {
          const bootstrapModal = bootstrap.Modal.getInstance(modal);
          if (bootstrapModal) bootstrapModal.hide();
        }
      }
    });
  }


  document.querySelectorAll(".img-thumbnail").forEach(function (img) {
    img.addEventListener("mouseenter", function () {
      if (!this.classList.contains("clicked")) {
        this.style.backgroundColor = "#1b5ee8";
      }
    });

    img.addEventListener("mouseleave", function () {
      if (!this.classList.contains("clicked")) {
        this.style.backgroundColor = "#fff";
      }
    });
  });


  const containerForm = document.querySelector(".container-form");
  if (containerForm) {
    containerForm.addEventListener("submit", function (event) {
      // If default was already prevented (e.g., from previous validation), stop
      if (event.defaultPrevented) {
        event.preventDefault();
        return;
      }

      const txtTitle = document.getElementById("title");
      const tnames = document.querySelector('input[name="tnames"]');
      const tgroup = document.getElementById("tgroup");
      const fileupload = document.querySelectorAll(".file-input");
      //console.log(fileupload.length);

      const isCompounfText = tnames && tnames.value !== "" && tnames.value !== undefined;
      const isGroupOftext = tgroup && tgroup.value !== "" && tgroup.value !== undefined;
      const isFileUpload = fileupload.length > 0;


      // Remove validation styles
      document.querySelectorAll(".text-info").forEach(el => el.classList.remove("design-notvalid"));
      const spImageSystem = document.getElementById("spImageSystem");
      if (spImageSystem) spImageSystem.innerHTML = "";

      // Default image for video or empty
      const imagesystem = document.getElementById("imagesystem");
      if (config.designType === "video" && imagesystem && imagesystem.value === "") {
        imagesystem.value = "pv1";
      }
      if (imagesystem && imagesystem.value === "") {
        imagesystem.value = "pv1";
      }

      // === File Upload Validation ===
      if (isFileUpload) {
        for (let index = 0; index < fileupload.length; index++) {
          const fileInput = fileupload[index];
          if (fileInput.files.length === 0) {
            const hpoint = document.getElementById("hpoint_" + index);
            if (hpoint) hpoint.style.display = "block";

            let message = validation.validateInputFile();
            const lbl = document.getElementById("lblfieldvalidation_" + index);
            if (lbl) lbl.innerHTML = message;

            // Scroll to error
            if (lbl) {
              const scrollTarget = lbl.offsetTop - 400;
              window.scrollTo({ top: scrollTarget, behavior: "smooth" });
              window.setTimeout(() => window.scrollTo({ top: scrollTarget, behavior: "smooth" }), 100);
            }

            event.preventDefault();
            return;
          }
        }
      }

      // === Group of Text Validation ===
      if (isGroupOftext) {
        const datagroup = tgroup.getAttribute("data-group-for");
        const controlTogroup = document.querySelector(`input[name="${datagroup}"]`);
        let valuesTogroup = "";
        const valuesArray = [];

        const textControls = tgroup.value.split(",");

        for (let index = 0; index < textControls.length; index++) {

          const controlId = textControls[index].trim();
          const validationLabel = Array.from(document.querySelectorAll(".field-validation-valid"))
            .find(el => el.getAttribute("data-valmsg-for") === controlId);

          if (!validationLabel) continue;

          const emptyMessage = validationLabel.getAttribute("data-valmsg-empty");
          const wrongTypeMessage = validationLabel.getAttribute("data-valmsg-wtype");
          validationLabel.innerHTML = "";

          const textControl = document.getElementById(controlId);
          if (!textControl) continue;

          textControl.classList.remove("txt-notvalid");

          // Empty check
          if (textControl.value.trim() === "") {
            validationLabel.innerHTML = emptyMessage;
            validation.markNotValid(textControl);
            event.preventDefault();
            return;
          }

          // Number type validation
          if (validationLabel.getAttribute("data-type") === "number") {
            if (!validation.validateNumber(textControl.value)) {
              validation.markNotValid(textControl);
              validationLabel.innerHTML = wrongTypeMessage;
              event.preventDefault();
              return;
            } else {
              const lang = textControl.getAttribute("lang");
              if (lang === "arabic") {
                let textval = textControl.value;
                if (tnames && tnames.value) {
                  const firstControls = tnames.value.split(",");
                  const firstTextContent = document.getElementById(firstControls[0])?.value || "";
                  if (!utils.isEnglishLetters(firstTextContent) || utils.isEnglishLetters(firstTextContent)) {
                    textControl.value = textval.EntoAr();
                  }
                } else {
                  textControl.value = textval.EntoAr();
                }
              }
            }
          }

          valuesArray[index] = textControl.value;
        }

        // Combine values
        valuesTogroup = valuesArray.join("-");
        if (controlTogroup) controlTogroup.value = valuesTogroup;
      }

      // === Compound Text Validation ===
      if (isCompounfText) {
        const textControls = tnames.value.split(",");

        for (let index = 0; index < textControls.length; index++) {

          let currentInputType = textControls[index].trim();

          const jsTextControl = document.getElementById(currentInputType);
          if (!jsTextControl) continue;

          let validationLabel = Array.from(document.querySelectorAll(".field-validation-valid"))
            .find(el => el.getAttribute("data-valmsg-for") == currentInputType);

          if (validationLabel) validationLabel.innerHTML = "";

          const jsSpanValidator = jsTextControl.nextElementSibling?.nextElementSibling;
          if (jsSpanValidator) jsSpanValidator.innerHTML = "";

          const wrongTypeMessage = validationLabel?.getAttribute("data-valmsg-wtype") || "";
          const emptyNumbers = validationLabel?.getAttribute("data-valmsg-empty") || "";
          const textControl = jsTextControl;

          textControl.classList.remove("txt-notvalid");
          const textControlContent = textControl.value.trim();
          // ensure the data-type not a number
          if (textControl?.getAttribute("data-type") === "number") {

            if (!validation.validateNumber(textControl.value)) {
              const validateUser = validation.validateName(textControl.value, true);
              validation.markNotValid(textControl);
              if (validationLabel) validationLabel.innerHTML = validateUser.message;
              event.preventDefault();
              return;
            }
            if (textControl.value.trim() === "") {
              if (validationLabel) validationLabel.innerHTML = emptyNumbers;
              validation.markNotValid(textControl);
              event.preventDefault();
              return;
            }
          } else {
            const validateUser = validation.validateName(jsTextControl.value);
            if (!validateUser.isValid) {
              validation.markNotValid(textControl);
              if (jsSpanValidator) jsSpanValidator.innerHTML = validateUser.message;
              event.preventDefault();
              log.logUserExtraDetails(validateUser.message, jsTextControl.value);
              return;
            }
          }

          // Remove emojis
          textControl.value = utils.removeEmojis(textControlContent);

          const lang = textControl.getAttribute("lang");
          if (lang === "arabic") {
            let textval = textControl.value.trim();
            const firstText = document.getElementById(textControls[0]);
            const firstTextContent = firstText ? firstText.value : "";
            if (!utils.isEnglishLetters(firstTextContent) || utils.isEnglishLetters(firstTextContent)) {
              textControl.value = textval.EntoAr();
            }
          }
        }

        // Image system required
        if (imagesystem && imagesystem.value === "") {
          document.querySelectorAll(".text-info").forEach(el => el.classList.add("design-notvalid"));
          if (spImageSystem) spImageSystem.innerHTML = config.errorMessageForSelectDesign;

          const firstTextInfo = document.querySelector(".text-info");
          if (firstTextInfo) {
            window.scrollTo({ top: firstTextInfo.offsetTop, behavior: "smooth" });
          }
          event.preventDefault();
          return;
        }
      } else {
        // Single title validation
        const validationLabels = Array.from(document.querySelectorAll(".field-validation-valid"))
          .filter(el => el.id !== "spImageSystem");

        validationLabels.forEach(label => label.innerHTML = "");

        const titleContent = txtTitle ? txtTitle.value : "";
        const validateUser = validation.validateName(titleContent);

        if (!validateUser.isValid) {
          const targetLabel = validationLabels[0] || document.querySelector(".field-validation-valid");
          if (targetLabel) targetLabel.innerHTML = validateUser.message;
          validation.markNotValid(txtTitle);
          event.preventDefault();
          log.logUserExtraDetails(validateUser.message, titleContent);
          return;
        }
      }

      // === Save form data to sessionStorage ===
      const data = utils.collectData();
      sessionStorage.setItem(config.formDataKey, JSON.stringify(data));

      // === Load Bootstrap & Show Captcha ===
      utils.loadBootstrapIfNeeded().then(() => {
        const token = utils.generateGUID();
        ui.showCaptchaModal(token);
        utils.submitUserState();
      });

      // Update button & prevent submission
      const submitButton = this.querySelector("button");
      if (submitButton) {
        submitButton.innerHTML = "..من فضلك أنتظر";
        submitButton.setAttribute("disabled", "disabled");
      }

      event.preventDefault();
    });
  }

  // Remove validation class on title focus
  if (titleInput) {
    titleInput.addEventListener("focus", function () {
      this.classList.remove("txt-notvalid");
    });
  }


  // Image thumbnail click handler
  document.querySelectorAll(".img-thumbnail").forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      // Reset all options
      document.querySelectorAll(".choose-img").forEach(el => {
        el.style.display = "none";
      });
      document.querySelectorAll(".img-thumbnail").forEach(el => {
        el.classList.remove("clicked");
        el.style.backgroundColor = "#fff";
      });

      // Highlight selected
      this.style.backgroundColor = "#66c227";
      const currentImg = this.querySelector("img");

      const rankId = currentImg.getAttribute("data-rank");

      const chooseImg = document.getElementById("choose-img" + rankId);
      if (chooseImg) {
        chooseImg.style.display = "block";
      }

      this.classList.add("clicked");

      // Extract image name
      // let imgSrc = currentImg.src;
      // let lx = imgSrc.lastIndexOf("/");
      // let imgName = imgSrc.substring(lx + 1);
      // imgName = imgName.replace(".jpg", "").replace(".webp", "");

      // Reset validation UI
      const lblHelper = document.getElementById("lblHelper");
      if (lblHelper) lblHelper.classList.remove("validation");

      const designsContainer = document.getElementById("designsContainer");
      if (designsContainer) designsContainer.classList.remove("notvalid");

      //console.log("Image Name : " + imgName);

      // Set hidden value
      const imagesystem = document.getElementById("imagesystem");
      if (imagesystem) imagesystem.value = `pv${rankId}`;

    });
  });

}

export function fireIndexPageEvents() {
  // clear last image sent to server
  // create token to prevent cache pages
  // createToken();
  utils.clearLocalStorageImages();
  // validate if user open my link from Facebook or not
  if (utils.isFacebookApp()) {
    // is Android show message to navigate user to default browser instead of Facebook webview.
    if (utils.isAndroid()) {
      utils.loadBootstrapIfNeeded()
        .then(() => {
          ui.createNavigationWindow(config.navigateExternalKey);
        })
    }
  }
  // add new function to build checkboxes and create each one with input
  ui.buildCheckBoxesForInputs();
  // load state if user check the save data
  utils.setUserStates();
  // track user
  // why this function log.trackUser() called twice in runtime
  log.trackUser().then(function (data) {

    //filter people
    config.dataCloud = data;
    // add alert function 
    // everything loaded show the message of warning in index page
    if (!config.isCrawlers) {
      // Disable it and test
      // just disable it
      // showWarningMessage();
    }
    if (utils.isDesktop()) {
      ui.fireWarningForPc();
    }
    if (settingData.general.isnotwaiting != undefined) {
      // ui.hideLoaderContainer();
    }
    if (settingData.general.design == "video") {
      // disable loader because no images to load in index
      ui.hideLoaderContainer();
    }
    // validate if the design has radio buttons
    if (settingData.radioButtons != undefined) {
      fireRadioButtonEvents();
    }
    if (settingData.general.type == "uploadPhotos") {
      utils.loadBootstrapIfNeeded()
        .then(() => {
          cropperhandler.fireUploadCallBack(settingData);
        })

    }
    if (settingData.general.isinv != undefined) {
      // fireSendInvitationCheckBkEvents(settingData);
    }

    // start event ..
    callEvents(settingData);
    fireImageLoadEvent(settingData);

    // googleevents.loadGooglScript();
    googleevents.fillAdsenceContainers("index");
    toggleContentEventListener();

  });
}

/**
 * toggle content eventListener
 */
export function toggleContentEventListener() {
  document.querySelectorAll('.toggle-content').forEach(toggle => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      const contents = document.querySelectorAll('.p-content');
      const eye = this.querySelector("i");
      // Check current state based on first content element
      const isVisible = contents[0].style.display !== 'none';
      // Toggle all content elements
      contents.forEach(content => {
        content.style.display = isVisible ? 'none' : 'block';
      });
      // Update button content
      if (isVisible) {
        this.innerHTML = '<i class="fas fa-eye-slash"></i> أضغط هنا لإظهار الشرح ';
      } else {
        this.innerHTML = '<i class="fas fa-eye"></i> أضغط هنا لإخفاء الشرح ';
      }
    });
  });
}

function fireRadioButtonEvents() {
  validation.enableValidationFor(["t1"]);

  document.querySelectorAll('input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', function () {
      if (!this.checked) return; // safety

      console.log('Fire button events ...');
      const val = this.value;
      const tnamesInput = document.querySelector("[name='tnames']");
      if (tnamesInput) {
        switch (val) {
          case "1":
            validation.enableValidationFor(["t1"]);
            utils.hideElement(["t2", "t3", "t4"], false);
            tnamesInput.value = "t1";
            break;
          case "2":
            utils.hideElement(["t1", "t2"], true);
            validation.enableValidationFor(["t1", "t2"]);
            utils.hideElement(["t3", "t4"], false);
            tnamesInput.value = "t1,t2";
            break;
          case "3":
            tnamesInput.value = "t1,t2,t3";
            utils.hideElement(["t1", "t2", "t3"], true);
            validation.enableValidationFor(["t1", "t2", "t3"]);
            utils.hideElement(["t4"], false);
            break;
          case "4":
            tnamesInput.value = "t1,t2,t3,t4";
            utils.hideElement(["t1", "t2", "t3", "t4"], true);
            validation.enableValidationFor(["t1", "t2", "t3", "t4"]);
            break;
        }
      }
    });
  });
}
/**
 * images load events when finished loader hide and image container appear
 * @param {object} settingData 
 * @returns 
 */
function fireImageLoadEvent(settingData) {
  if (settingData.general?.isnotwaiting) {
    ui.hideLoaderContainer();
    ui.showImagesContainer();
    return;
  }
  // skip the whole logic

  const images = document.querySelectorAll('.preview-img');
  const total = settingData.general?.imagesCount ?? images.length;

  let loadedCount = 0;

  const checkAllLoaded = () => {
    loadedCount++;
    if (loadedCount === total) {
      ui.hideLoaderContainer();
      ui.showImagesContainer();
    }
  };

  images.forEach(img => {
    // If the image is already cached (complete = true)
    if (img.complete && img.naturalWidth !== 0) {
      checkAllLoaded();
      return;
    }

    // Normal load path
    img.addEventListener('load', checkAllLoaded);

    // In case of broken image (error fires instead of load)
    img.addEventListener('error', checkAllLoaded);
  });
}


/**
 * EventListener of image load before showing the final design
 * @param {object} settingData 
 * @returns 
 */
// export function handleDownloadImageLoad(settingData) {

//   const downloadImage = document.querySelector(".download-image");
//   const loaderContainer = document.querySelector(".loader-container");
//   const imageDesigned = document.querySelector(".image-designed");
//   const messageBox = document.querySelector(".message");
//   const downloadPhoneBtn = document.querySelector(".download-T-Phone");

//   if (!downloadImage) return;

//   downloadImage.addEventListener("load", function () {

//     if (loaderContainer) {
//       loaderContainer.style.display = "none";
//     }
//     // check isShow modal exists or not

//     // تجهيز بيانات الصورة
//     const imageElement = document.getElementsByClassName("download-image")[0];
//     if (imageElement) {
//       //imageElement.setAttribute("crossorigin", "anonymous");
//     }
//     let isShareAttr;
//     if (imageDesigned) {
//       isShareAttr = imageDesigned.getAttribute("data-share");
//     }
//     if (isShareAttr === null || isShareAttr === undefined) {
//       if (imageDesigned) {
//         imageDesigned.style.display = "";
//       }

//       const imagesContainer = document.querySelector(".images-container");
//       if (imagesContainer) {
//         const adsContainer = imagesContainer.parentElement?.closest("div");
//         if (adsContainer) {
//           adsContainer.style.display = "";
//         }
//       }


//       if (messageBox) {
//         messageBox.style.display = "";
//       }
//     }
//     //const forceShare = settingData?.general?.forceShare ?? false;
//     // console.log("forceShare : " + forceShare);
//     if (config.isForceShare) {
//       const isShareToday = utils.getLocalStorageValue(config.sharedTodayKey);
//       if (downloadPhoneBtn) {
//         // if (isShareToday || config.isUserNotApplicable) {
//         downloadPhoneBtn.style.display = "";
//         // } else {
//         //   downloadPhoneBtn.style.display = "none";
//         // }
//       }

//       ui.createWarningImageDownload(
//         window.location.origin + "/" + config.designName
//       );
//     } else {
//       if (downloadPhoneBtn) {
//         downloadPhoneBtn.style.display = "";
//       }
//     }
//     // check isShow modal exists or not 
//     ui.showModalBasedOnShare(settingData);
//     if (config.isForceShare) {
//       // ui.scrollToDownloadImage();
//     }
//     if (resultTitle) {
//       resultTitle.style.visibility = 'visible';
//     }
//   });
// }

export function handleDownloadImageLoad(settingData) {

  const downloadImage = document.querySelector(".download-image");
  const loaderContainer = document.querySelector(".loader-container");
  const imageDesigned = document.querySelector(".image-designed");
  const messageBox = document.querySelector(".message");
  const downloadPhoneBtn = document.querySelector(".download-T-Phone");

  if (!downloadImage) return;

  let retryCount = 0;
  const maxRetries = 3;

  downloadImage.addEventListener("error", function () {

    if (retryCount < maxRetries) {
      retryCount++;

      console.warn(
        `Image loading failed. Retrying ${retryCount}/${maxRetries}...`
      );

      setTimeout(() => {
        downloadImage.src =
          downloadImage.src.split("?")[0] +
          "?retry=" +
          Date.now();
      }, 1000 * retryCount);

      return;
    }

    console.error("Image failed after maximum retries.");
  });

  downloadImage.addEventListener("load", function () {

    retryCount = 0;

    if (loaderContainer) {
      loaderContainer.style.display = "none";
    }

    let isShareAttr;

    if (imageDesigned) {
      isShareAttr = imageDesigned.getAttribute("data-share");
    }

    if (isShareAttr === null || isShareAttr === undefined) {

      if (imageDesigned) {
        imageDesigned.style.display = "";
      }

      const imagesContainer =
        document.querySelector(".images-container");

      if (imagesContainer) {

        const adsContainer =
          imagesContainer.parentElement?.closest("div");

        if (adsContainer) {
          adsContainer.style.display = "";
        }
      }

      if (messageBox) {
        messageBox.style.display = "";
      }
    }

    if (config.isForceShare) {

      const isShareToday =
        utils.getLocalStorageValue(config.sharedTodayKey);

      if (downloadPhoneBtn) {
        downloadPhoneBtn.style.display = "";
      }

      ui.createWarningImageDownload(
        window.location.origin + "/" + config.designName
      );

    } else {

      if (downloadPhoneBtn) {
        downloadPhoneBtn.style.display = "";
      }
    }

    ui.showModalBasedOnShare(settingData);

    if (resultTitle) {
      resultTitle.style.visibility = "visible";
    }
  });
}
export function fireEventsCallback(settingData) {

  /*****************FIRE EVENTS FROM HERE *************/
  // it should hide until images loaded
  // if setting has IsNotWaiting images load directly
  // overload methods
  ui.changeFooterDiv();
  ui.fireHamburgerMenuEvents();
  ui.fireSmoothAnimation();
  let isDownload = utils.isDownloadPage();

  const imagesContainer = document.querySelector(".images-container");
  const imageDesigned = document.querySelector(".image-designed");
  const plzWaitIndex = document.querySelector(".plz-wait-index");

  if (settingData.general.isnotwaiting == undefined) {

    if (settingData.general.type != "category") {
      if (imagesContainer) {
        imagesContainer.style.display = "";
      }
    }
  }
  if (imageDesigned != null) {
    imageDesigned.style.display = "none";
  }

  switch (settingData.general.design) {
    case "image":
      config.designType = "image";
      if (plzWaitIndex) {
        plzWaitIndex.textContent =
          isDownload ? "جاري تجهيز تصميمك" : "من فضلك أنتظر لتحميل التصميمات";
      }
      break;
    case "video":
      config.designType = "video";
      if (plzWaitIndex) {
        plzWaitIndex.textContent = "من فضلك أنتظر لتحميل الفيديو";
      }
      break;
  }

  // Rest of the switch statement remains the same...

  switch (config.pageType) {
    case "index":
      fireIndexPageEvents();
      break;
    case "download":
      fireDownloadPageEvents();
      break;
    case "single":
      log.trackUser().then(function (data) {
        //filter people
        config.dataCloud = data;
        fireSinglePageEvents();
        //  fillAdsenceContainers("index");
      });
      break;
    case "category":

      log.trackUser().then(function (data) {
        //filter people

        config.dataCloud = data;
      });

      break;
    case "home":
      log.trackUser().then(function (data) {
        //filter people
        config.dataCloud = data;
        fireSinglePageEvents();
        // fillAdsenceContainers("index");
      });
      break;
  }

}

function fireDownloadPageEvents() {
  // Download clicks save the file onto the device instead of opening it in
  // the browser: cross-origin result URLs (the render servers) are fetched
  // as a blob and saved locally (see ui.saveUrlAsFile); when that is not
  // possible the link opens exactly as it always did. The confirmation
  // toast fires only when a save was actually triggered. Delegated because
  // some download anchors are created dynamically.
  document.addEventListener("click", async (e) => {
    const anchor = e.target.closest(".download-T-Phone");
    if (!anchor) return;
    const url = anchor.getAttribute("href");
    if (!url || url.startsWith("#")) return;
    const showSavedToast = () =>
      ui.showToast(config.designType === "video" ? "تم تحميل الفيديو على جهازك" : "تم تحميل الصورة على جهازك");
    let isLocal = url.startsWith("blob:") || url.startsWith("data:");
    if (!isLocal) {
      try {
        isLocal = new URL(url, window.location.href).origin === window.location.origin;
      } catch (error) {
        isLocal = false;
      }
    }
    if (isLocal) {
      // Same-origin / blob / data links download natively; give the saved
      // file a proper name and confirm.
      anchor.setAttribute("download", ui.downloadFileName(url));
      showSavedToast();
      return;
    }
    e.preventDefault();
    if (anchor.dataset.saving) return;
    anchor.dataset.saving = "1";
    const saved = await ui.saveUrlAsFile(url);
    delete anchor.dataset.saving;
    if (saved) showSavedToast();
    else window.location.href = url;
  });
  // "Create a new design" repeats this design: a fresh forward navigation
  // back to the design's page instead of the browser's back button, so the
  // page (and its ads) load anew. Placed right under the download button.
  const downloadAnchor = document.querySelector(".download-T-Phone");
  if (downloadAnchor && config.designName) {
    const repeatLink = document.createElement("a");
    repeatLink.className = "repeat-design-btn";
    repeatLink.href = `/${config.designName}/`;
    repeatLink.textContent = "إنشاء تصميم جديد";
    downloadAnchor.after(repeatLink);
  }
  let params = utils.getDataFromSessionStorage();
  let resource = utils.isSameResources();
  let isTheSameResource = resource.isSameResource;
  // hide download link

  // check only is resources not ready
  if (params != undefined) {
    // save your time and check if the download page is valid or not
    let currentDesignName = params.get("designname");

    if (settingData.general.href != currentDesignName) {
      config.isDownloadPageValid = false;
    }
  } else {
    if (!isTheSameResource) {
      config.isDownloadPageValid = false;
    }
  }
  ui.removeStyleFromDownloadBox(true, false);


  utils.isUserExceededTries();

  // if (config.isExceedDesign) {
  //   ui.hideLoaderContainer();
  //   googleevents.fillAdsenceContainers("download");
  //   return;
  // }

  log.trackUser().then(function (data) {
    config.dataCloud = data;
    if (utils.isDesktop()) {
      ui.fireWarningForPc();
      config.maxTotalDownloadPerCountry = config.maxDesktopDownload;
    }
    if (config.isUserProxyRequest || config.isUserBlockedCookies)
      return;
    //  if(isgMediaP){
    //    ui.createglMessage();
    //    return;
    //  }

    const cookieOfCountry = utils.getCookie("country");
    let countries = ["EG", "US", "CA", "NL", "GB", "MA", "FR", "SD", "JO", "DZ", "SE"];
    let isExistsCountry = false;
    let isExceed = false;
    for (let index = 0; index < countries.length; index++) {
      if (cookieOfCountry == countries[index]) {
        // settingData.general.countOfattemp = 2; // disable now
        //settingData.general.balanceCount = 2; // disable now
        isExistsCountry = true;
        break;
      }
    }
    if (isExistsCountry) {
      isExceed = utils.validateTotalDownloadPerCountry(config.maxTotalDownloadPerCountry);
    }
    if (!isExceed) {
      // check if the design has messageShare
      if (settingData.general.showfbbutton != undefined) {
        // check if the user comes from desktop or not
        if (!utils.isDesktop()) {
          const shareDiv = document.querySelector('.fb-shared');
          if (shareDiv) {
            ui.createFbShareMessage(
              "للمزيد من التصميمات المجانية قم بعمل مشاركة واحدة",
              settingData,
              shareDiv,
              config.designName
            );
          }
        }
      }
      ui.createMessage(config.usermessage, ".message");
      // initalize EventListeners to page

      initalizeEventListeners(settingData, config.designName, config.dataCloud);
      //utils.fillTotalDownload();
      // ceate a description div to help people save images in phone devices

    }
    utils.loadBootstrapIfNeeded()
      .then(() => {
        ui.createSendToFriendModal();
      })
      .catch(error => {
        console.error("Error loading Bootstrap:", error);
      });

  });
  //googleevents.loadGooglScript();
  googleevents.fillAdsenceContainers("download");
  ui.createHowToSaveImageDescription();
  // test

}

/**
 * Handles clicks on share/download buttons inside modal (event delegation)
 *  @param {Object} settingData - Your config object
 */
function fireClickOnModalButton(settingData) {
  // Only add listener if modal/share is enabled


  if (!settingData?.general?.showModal) return;
  // Use event delegation on a static parent (or document.body)
  const mainContainer = document.querySelector('.main-container');
  if (mainContainer) {
    mainContainer.addEventListener('click', function (e) {
      const button = e.target.closest('.btn-sh');
      if (!button) return; // Not a .btn-sh click
      const url = button.getAttribute('href');
      if (!url) return;
      e.preventDefault(); // Stop normal navigation
      // Optional: detect iPhone and track download
      // if (isiPhone()) insertAppUser("download");

      // Redirect safely
      window.location.href = url;
    });
  }
}

/**
 * Runs code when the download image finishes loading
 * 
 * @param {Object} settingData - Your config object
 */
function fireDownloadImageLoadedEvent(settingData) {
  const img = document.querySelector('.download-image');
  if (!img) return;
  // If image is already loaded (cached), trigger immediately
  if (img.complete && img.naturalWidth > 0) {
    ui.showModalBasedOnShare(settingData);
    if (config.isForceShare) {
      ui.scrollToDownloadImage();
    }
    return;
  }
  // Otherwise wait for load event
  img.addEventListener('load', function () {
    ui.showModalBasedOnShare(settingData);
    console.log("image load event");
    if (config.isForceShare) {
      ui.scrollToDownloadImage();
    }
  });
  // Optional: handle error case
  img.addEventListener('error', () => {
    console.warn('Download image failed to load');
  });
}
// test
export function initModule(startFn) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startFn);
  } else {

    startFn();
  }
}
/**
 * 
 * @param {object} settingData 
 * @param {string} designName 
 * @param {object} dataCloud 
 */
function initalizeEventListeners(settingData, designName, dataCloud) {


  handleDownloadImageLoad(settingData);
  let adsClass = "." + settingData.general.divClassContainer + "-ads";
  fireClickOnModalButton(settingData);
  // start from here 
  let postid = settingData.general.fbpostid;
  //console.log(postid)
  //let adsClass = "." + settingData.general.divClassContainer + "-ads";
  let addsResource = settingData.general.divClassContainer;

  let cookieName = designName;

  // MUST UPDATE IF WE ADD followTotalDownload
  let countOfattemp = 0;
  if (settingData.general.countofattemp) {
    if (config.domain.indexOf('localhost') != -1) {
      countOfattemp = parseInt(settingData.general.countofattemp);

    }

  }
  let countofattempBouns = countOfattemp * 2;

  // let shareOneTime = utils.getCookie(`fb-${cookieName}`);
  let shareOneTime = utils.getLocalStorageValue(`fb-${cookieName}`);
  let balanceCount = parseInt(settingData.general.balanceCount);
  let cookieBalancName = cookieName + "balance";
  //let balance = utils.getCookie(cookieBalancName);

  let fbBack = utils.getQueryValue("fbback");
  let cookie = utils.getLocalStorageValue(cookieName);
  let tryHitsCount = parseInt(cookie);
  // call the main message
  ui.createMessage(config.usermessage, ".message");
  //postid = "3887060964716814";

  var url = window.location.href.replace(
    "&error_code=4201&error_message=User%20canceled%20the%20Dialog%20flow#_=_",
    ""
  );
  url += "&fbback=y";
  const pageurl = encodeURIComponent(url);

  var fburl = utils.createFbUrl(config.appId, settingData, config.pageId, designName, pageurl);
  if (postShare) {
    postShare.setAttribute("href", fburl);
    postShare.addEventListener("click", function () {
      utils.setToLocalStorage(`${config.noShareStatus}-${designName}`, 0, -6);
    });
  }
  if (utils.isResultPage()) {

    // in case is download page comes but not valid
    //console.log(`Is Valid : ${config.isDownloadPageValid}`);
    if (!config.isDownloadPageValid) {
      ui.hideLoaderContainer();
      if (postShare) {
        postShare.style.display = 'none';
      }

      if (imageContainer) {
        imageContainer.style.transition = "opacity 300ms, display 300ms";
        imageContainer.style.opacity = "0";
        imageContainer.style.removeProperty('display');
        imageContainer.offsetHeight;
        // Animate to full opacity
        imageContainer.style.opacity = "1";
      }
      // log user and finish the request
      ui.createglMessage();
      log.logUserExtraDetails("User try to access download page without data", designName);
      return;
    }
    // is valid download page 
    if (imageDesigned) {
      imageDesigned.style.removeProperty('display');
    }
    countOfattemp = parseInt(settingData.general.countofattemp);


    if (config.domain.indexOf('localhost') == -1) {
      // if user flagNotShared decrease count of attemp
      if (utils.getLocalStorageValue(`${config.noShareStatus}-${designName}`)) {
        if (!utils.isFromGolfCountries()) {
          countOfattemp = 2;
        }

      }
    }
    var isvalid = validation.validatCookie(cookieName, countOfattemp, fburl);

    if (isvalid) {
      // never calculate
      // console.log(isShowModal);
      let _resource = utils.isSameResources();
      if (!_resource.isSameResource) {
        utils.fillTotalDownload();
      }
      if (shareOneTime != null && !_resource.isSameResource) {
        let countOfTries = parseInt(shareOneTime);
        countOfTries++;
        //utils.setCookie(`fb-${cookieName}`, countOfTries);
        utils.setLocalStorageWithFlagExpiry(`fb-${cookieName}`, countOfTries);
        //console.log("countOfTries : " + countOfTries +" countofattempBouns : " + countofattempBouns)
        if (countOfTries > countofattempBouns) {
          utils.setAttempNumber(cookieName);
        }
      }
      else if (shareOneTime == null && !_resource.isSameResource) {
        utils.setAttempNumber(cookieName);
      }

      utils.connect(settingData, dataCloud);
      if (imageContainer) {
        imageContainer.style.removeProperty('display');; // remove any display: none
        imageContainer.animate(
          [{ opacity: 0 }, { opacity: 1 }],
          { duration: 300, fill: 'forwards' }
        );
      }
      // Show ads with 1500ms fade-in
      if (adsElements) {
        adsElements.forEach(el => {
          el.style.removeProperty('display');; // remove inline display: none if exists
          el.animate(
            [{ opacity: 0 }, { opacity: 1 }],
            { duration: 1500, fill: 'forwards' }
          );
        });
      }

    } else {
      // not valid
      ui.hideLoaderContainer();
      config.isExceedDesign = true;
    }
  }
  //});
}

/**
 * FireImageDesignedSuccess is the longest function
 * explain how image comes from request of web api
 * @param {object} settingData 
 * @param {object} data 
 * @param {string} url 
 * @param {boolean} isCached 
 * @param {object} dataCloud 
 * @returns 
 */
export function fireImagedesignedSuccess(settingData, data, url, isCached, dataCloud = null) {
  config.cloneDesign = data;

  if (config.isBadRequest || data == null) {
    utils.handleCookiesinError("_tdownload");
    utils.handleCookiesinError(config.designName);
    ui.hideLoaderContainer();
    let isDesignWithPhoto = settingData.general.type == "uploadPhotos" ? true : false;
    //let isLocalStorageProblem = false;
    if (isDesignWithPhoto) {
      // it must return the image
      let item = localStorage.getItem("img0");
      if (item == null) {
        // localstorage may be cleared or not work with the client
        // custum error
        let error = `Problem in localStorage it return null, domain ${config.domain} return 400 code`;
        log.logUserExtraDetails(error, null);
      }
      else {
        let error = `localStorage not null but there's a problem, domain ${config.domain} return 400 code`;
        log.logUserExtraDetails(error, null);
      }
    }
    else {
      // design not upload photos but has error check the host
      let error = `Simple design but we don't know why this error has been check the names, domain ${config.domain} return 400 code`;
      log.logUserExtraDetails(error, null);
    }

    let params = utils.getDataFromSessionStorage()
    let fn = params.has('fn');
    var htmlError;
    if (fn) {
      // check if localstorage has images or not
      if (localStorage?.length == 0) {
        htmlError = ui.createErrorAndNavigateToIndex();
      } else {
        htmlError = ui.createErrorInfo();
      }
    } else {
      htmlError = ui.createErrorInfo();
    }
    if (imageDesigned) {
      imageDesigned.innerHTML = htmlError;
      imageDesigned.setAttribute("display", "flex");
    }
    if (fbSharedDiv) {
      fbSharedDiv.setAttribute("display", "none");
    }
    config.domain = decodeURI(window.location.href);
    return;
  }
  // hide download-T-Phone until image load
  if (downloadTPhoneDiv) {
    // console.log('hide the download link');
    // downloadTPhoneDiv.setAttribute("style", "display: none");
    // resultTitle.setAttribute("style", "display: none");
  }
  var countofImages = data.imagesDesigned.length;
  //if (config.domain.indexOf('localhost') == -1) {
  try {
    utils.runNotApplicableRules();
    //if (settingData.general?.showModal != undefined) {
    // show message when design is force to share or even show modal only and give the user the option to share or not
    if (config.isForceShare || config.ShowModal) {
      ui.createModalUserMessage(settingData);
    }
    // }
    //else {
    // check other modals here
    //settingData.general.showSurvey !=undefined
    // check if this option enable in system
    // disable survey-1
    utils.loadBootstrapIfNeeded()
      .then(() => {
        // createSurveyModal(settingData,'survey-1');
      })
      .catch(error => {
        console.error("Error loading Bootstrap:", error);
      });

    //}
  } catch (ex) {
    console.log(ex);
  }
  // }
  var titlesCount = settingData.textBoxes.length;
  let isTitle = titlesCount > 1 ? false : true;
  let names = '';
  if (isTitle) {
    names = utils.getQueryValue('title');
  }
  for (let titleIndex = 0; titleIndex < titlesCount; titleIndex++) {
    let queryname = settingData.textBoxes[titleIndex].name;
    if (queryname != "title") {
      names += queryname + "= " + decodeURI(utils.getQueryValue(queryname));
      if (titleIndex < titlesCount - 1) {
        names += " , ";
      }
    }
  }
  let fn = utils.getQueryValue('fn');
  if (fn != "") {
    fn = fn + ".jpg";
  }
  //let designname = getQueryValue('designname');
  // change it just for test

  if (
    settingData.hosts != undefined &&
    settingData.general.provider != undefined
  ) {
    if (settingData.general.provider == "javascript") {
      //  console.log("provider:javascript");
      //url = url.substring(0, url.indexOf(".com") + 4);
      config.domain = url.substring(0, url.indexOf(".com") + 4);
      config.isUsePhpForDownload = false;
    }
  }
  let host = data.domainUrl.replace("/images/shared", "");
  if (data.error != null) {
    utils.handleCookiesinError("_tdownload");
    utils.handleCookiesinError(config.designName);
    ui.hideLoaderContainer();
    const htmlError = ui.createErrorInfo();
    if (imageDesigned) {
      imageDesigned.innerHTML = htmlError;
      imageDesigned.setAttribute("display", "flex");
    }
    if (fbSharedDiv) {
      fbSharedDiv.setAttribute("display", "none");
    }
    config.domain = decodeURI(window.location.href);
    if (!isCached)
      apihandler.logUsers(config.designName, "", "Error", data.domainUrl, names, config.ref, dataCloud);
    return;
  }
  if (countofImages == 1) {
    // here validate Error which comes from web api
    var newurl = config.domain + "/images/shared/" + data.imagesDesigned[0];
    let imageCahcedName = "";

    let designedObject = {
      "designName": config.designName,
      "designType": "image",
      "imageName": data.imagesDesigned[0],
      "host": data.domainUrl.replace("/images/shared", ""),
      "fn": fn,
      "createdAt": new Date().toLocaleString(),
      "names": decodeURI(names),
    }
    // get the current items by key
    let designObjects = utils.getStoredDesigns(config.historyKey);
    let existsDesign = false;
    designObjects.forEach((item, index) => {
      if (item.imageName == data.imagesDesigned[0]) {
        existsDesign = true;
      }
    });
    if (isCached) {
      imageCahcedName = data.imagesDesigned[0];
      imageCahcedName = imageCahcedName.substring(imageCahcedName.lastIndexOf('/') + 1);
      newurl = config.isUsePhpForDownload ? `${config.domain}/images/shared/${imageCahcedName}` : data.domainUrl + "/" + data.imagesDesigned[0];
      if (config.isForceShare == true) {
        var isSharedable = utils.getLocalStorageValue(`${config.noShareStatus}-${config.designName}`) === null ? true : false;
        // save to localStorage
        if (isSharedable) {
          if (!existsDesign) {
            utils.saveDesignObject(designedObject, config.historyKey);
          }
        }

      } else {
        // save in local storage if no share required
        if (!existsDesign) {
          utils.saveDesignObject(designedObject, config.historyKey);
        }
      }
    }

    if (data.localUrl) {
      newurl = data.localUrl;
    }
    if (downloadImageDiv) {
      downloadImageDiv.setAttribute("src", newurl);
    }
    // this part for sendToFriend
    if (settingData.general.sendToFriend != null) {
      let sendToFriendDiv = document.createElement("div");
      sendToFriendDiv.innerHTML = ui.createSendToFriendContainer();
      if (boxImage) {
        boxImage.prepend(sendToFriendDiv);
      }
      const openBtn = document.getElementById("openSendToFriendModal");

      // add event listener to open modal
      if (openBtn) {
        openBtn.addEventListener("click", (e) => {
          e.preventDefault();
          utils.loadBootstrapIfNeeded()
            .then(() => {
              const modalElement = document.getElementById("sendToFriendModal");
              const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
              modal.show();
            });

        });
      }
    }
    // change icon <i>
    if (downloadTPhoneDiv) {
      const icon = downloadTPhoneDiv.querySelector('i');
      if (icon) {
        icon.className = 'fas fa-2x fa-download';
      }
      //change text
      const span = downloadTPhoneDiv.querySelector('span');
      if (span) {
        span.textContent = 'اضغط للتحميل الآن';
      }
    }
    let downloadimage = data.localUrl ? data.localUrl :
      (config.isUsePhpForDownload ?
        `${config.domain}/download.php?image=${data.imagesDesigned[0]}`
        : `${host}/api/download/${data.imagesDesigned[0]}`);
    if (downloadImageDiv) {
      downloadImageDiv.setAttribute("href", downloadimage);
    }
    if (downloadTPhoneDiv) {
      downloadTPhoneDiv.setAttribute("href", downloadimage);
    }
    if (data.invid != undefined) {
      let sharedLink = config.domain + "/sh/" + data.invid;
      let currentUrl = config.domain + "/" + config.designName;
      let facebookMessengerLink = `https://www.facebook.com/dialog/send?app_id=${config.facebookAppId}&display=popup&link=${sharedLink}&redirect_uri=${currentUrl}`;
      const fblinkMesenger = document.querySelector(".fblink-mesenger");
      if (fblinkMesenger) {
        fblinkMesenger.setAttribute("href", facebookMessengerLink);
      }
    } else {
      // maybe the div exists on content
      const fbMessenger = document.querySelector(".fb-messenger");
      if (fbMessenger) {
        fbMessenger.setAttribute("display", "none");
      }
    }
    names = names.replace("+", " ").replace("#gsc.tab=0", "");
    // history part start
    if (!isCached) {
      apihandler.logUsers(config.designName, fn, data.imagesDesigned[0], host, decodeURI(names), config.ref);
      if (!config.isForceShare) {
        // var isSharedable = getCookie(`${noShareStatus}-${designName}`) === null ? true : false;
        // save to localStorage
        let designedObject = {
          "designName": config.designName,
          "designType": "image",
          "imageName": data.imagesDesigned[0],
          "host": host,
          "fn": fn,
          "createdAt": new Date().toLocaleString(),
          "names": decodeURI(names),
        }
        if (!existsDesign) {
          utils.saveDesignObject(designedObject, config.historyKey);
        }
      }
    }

  } else {
    // multi images
    for (let i = 0; i < data.imagesDesigned.length; i++) {
      let imageurl = config.isUsePhpForDownload
        ? `${config.domain}/images/shared/${data.imagesDesigned[i]}`
        : `${data.domainUrl}${data.imagesDesigned[i]}`
      let downloadimage = config.isUsePhpForDownload
        ? `${config.domain}/download.php?image=${data.imagesDesigned[i]}`
        : `${host}/api/download/${data.imagesDesigned[0]}`;
      if (i == 0) {
        // catch first image
        if (downloadImageDiv) {
          downloadImageDiv.setAttribute("src", imageurl);
        }
        if (downloadTPhoneDiv) {
          downloadTPhoneDiv.setAttribute("href", downloadimage);
        }
      } else {
        // i !=0
        if (rowContainer) {
          rowContainer.appendChild(ui.createDownloadBlock(imageurl, downloadimage));
        }
        names = names.replace("+", " ");
        //disable function
        apihandler.logUsers(config.designName, fn, data.imagesDesigned[0], host, names, config.ref);
      }
    }
  }
  // back to main image
}

export function fireVideoDesignedSuccess(settingData, data, url, isCached, dataCloud = null) {
  config.cloneDesign = data;

  const designName = config.designName;
  if (config.isBadRequest) {
    utils.handleCookiesinError("_tdownload");
    utils.handleCookiesinError(designName);
    ui.hideLoaderContainer();

    const htmlError = ui.createErrorInfo();
    imageDesigned.innerHTML = htmlError
    //$(".image-designed").html(htmlError);
    imageDesigned.style.removeProperty('display'); // remove none

    // $('.fb-shared').hide();
    fbSharedDiv ?? (fbSharedDiv.style.display = 'none'); // 

    config.domain = decodeURI(location.href);
    return;
  }
  let host = isCached ? data.domainUrl : `${data.domainUrl}/${data.videoDesigned}`
  let downloadService = host.substring(0, host.indexOf('images'));
  downloadService += "api/download" + host.substring(host.indexOf("videos") + "videos".length);
  console.log(data);
  //let videoGuidId =host.substring(host.lastIndexOf("/" + 1));
  let videoDesigned = data.videoDesigned;

  let newurl = config.isUsePhpForDownload
    ? `${domain}/images/shared/videos/${data.videoDesigned}`
    : `${host}`;
  try {
    // run static options
    utils.runNotApplicableRules();
    if (config.ShowModal) {
      ui.createModalUserMessage(settingData);
      ui.showModalBasedOnShare(settingData);
      if (downloadTPhoneDiv) {
        downloadTPhoneDiv.setAttribute("src", newurl);
      }
      // Disable warning 
      ui.createWarningImageDownload(window.location.origin + "/" + designName);
    }

  } catch (exception) {
    console.log(`exception ${exception}`);
  }
  if (downloadImageDiv) {
    downloadImageDiv.setAttribute("src", newurl);
  }

  // create a video div
  const video = document.createElement("video");
  video.id = "video";
  video.style.maxWidth = "100%";
  video.classList.add("download-image");
  video.src = newurl;
  video.autoplay = true;
  video.loop = true;
  video.type = "video/mp4";
  video.controls = true;
  videoContainer.classList.add("container");
  videoContainer.appendChild(video);
  ui.hideLoaderContainer();
  imageDesigned.style.removeProperty('display');
  video.setAttribute("data-state", "play");
  video.setAttribute("autoplay", true);
  const titlesCount = settingData.textBoxes.length;
  let isTitle = titlesCount > 1 ? false : true;
  let names = '';
  if (isTitle) {
    names = utils.getQueryValue('title');
  } else {
    let tnames = utils.getQueryValue('tnames');
    if (tnames != undefined) {
      tnames = decodeURIComponent(tnames);
      let titles = tnames.split(',');
      for (let index = 0; index < titles.length; index++) {
        const title = titles[index];
        names += decodeURI(utils.getQueryValue(title));
        if (index < titles.length - 1) {
          names += " , ";
        }
      }
    }
  }
  let fn = utils.getQueryValue('fn');
  if (fn != "") {
    fn = fn + ".mp4";
  }
  if (!isCached)
    apihandler.logUsers(designName, fn, data.videoDesigned, host, decodeURI(names), config.ref);
  downloadTPhoneDiv.setAttribute("href", downloadService);
  if (!config.isForceShare) {
    downloadTPhoneDiv.style.removeProperty('display');
    resultTitle.style.removeProperty('display');
    //createImageCanvasAndDownloadLink(imageElement,imageName);
    ui.createWarningImageDownload(window.location.origin + "/" + designName);
  }
  if (data.invid != undefined) {
    let sharedLink = domain + "/sh/" + data.invid;
    let currentUrl = domain + "/" + designName;
    //https://www.facebook.com/dialog/send?app_id={facebookAppId}&display=popup&link={sharedLink}/&redirect_uri={return_url}
    let facebookMessengerLink = `https://www.facebook.com/dialog/send?app_id=${facebookAppId}&display=popup&link=${sharedLink}&redirect_uri=${currentUrl}`;
    //console.log(facebookMessengerLink);
    fbLinkMessenger.setAttribute("href", facebookMessengerLink);
    // $(".fblink-mesenger").attr("href", facebookMessengerLink);
  }
  else {
    // maybe the div exists on content
    if (fbMessenger) { fbMessenger.style.display = 'none'; }
  }
  const currentVideo = document.querySelector("video");
  if (currentVideo) {
    downloadTPhoneDiv.style.removeProperty('display');
    resultTitle.style.removeProperty('display');
    currentVideo.addEventListener("play", function () {
      const adsContainer = document.querySelector('.images-container')
        ?.closest('div')?.closest('div');
      if (adsContainer) {
        adsContainer.style.removeProperty('display');
        // adsContainer.style.removeProperty('display');
      }

      // console.log('I got the event');
    });
  }
  // back to main image
  if (imageDesigned && !imageDesigned.hasAttribute("data-share")) {
    imageDesigned.style.removeProperty('display'); // removes inline display:none, respects CSS
    const imagesContainer = document.querySelector(".images-container");
    if (imagesContainer) {
      const adsContainer = imagesContainer.parentElement?.closest("div");
      if (adsContainer) {
        adsContainer.style.removeProperty('display');
      }
    }
    if (messageDiv) {
      messageDiv.style.display = "block";
    }
  }
}

function fireSinglePageEvents() {
  const pageName = settingData.name; // get the page name
  switch (pageName) {
    case "home":
      fireHomePageEVents();
      break;


    case "support":
      fireSupportPageEvents();
      break;
    case "contact":
      fireContactPageEvents();
      break;
    case "messagedetails":
      fireMessageDetailsPageEvents();
      break;
    case "history":
      //delete confirmation event
      fireDeleteConfirmationEvent();
      // load history designs
      ui.renderDesigns();
      fireImageHistoryLoadEvent();
      googleevents.fillAdsenceContainers("history");
      break;

  }
}
function fireHomePageEVents() {
  ui.hideLoaderContainer();
  // load google
  //googleevents.fillAdsenceContainers("home");
}
function fireSupportPageEvents() {
  ui.hideLoaderContainer();
  apihandler.fetchUserMessages();
  // validate messageList
  messageList.style.visibility = "visible";
}
// explain this function for me 
function fireContactPageEvents() {
  if (!contactForm)
    return;
  let captchaAnswer = utils.generateCaptcha();
  const refreshId = document.querySelector('.refresh');
  const captchaBox = document.querySelector('.captcha-box');
  if (!captchaBox)
    return;
  captchaBox.innerHTML = captchaAnswer;
  if (refreshId) {
    refreshId.addEventListener('click', async function (e) {
      captchaAnswer = utils.generateCaptcha();
      captchaBox.innerHTML = captchaAnswer;
    });
  }
  // Voice message recorder, ported from the editor's suggestion modal:
  // tap to record (up to 5 minutes); the audio uploads with the submit.
  const MAX_RECORD_SECONDS = 300;
  const recordBtn = document.getElementById('recordBtn');
  const recordStatus = document.getElementById('recordStatus');
  const audioPreview = document.getElementById('audioPreview');
  let mediaRecorder = null;
  let audioChunks = [];
  let audioBlob = null;
  let recording = false;
  let recordSeconds = 0;
  let recordTimer = null;

  /** Format elapsed seconds as m:ss for the recording status line. */
  function formatRecordTime(totalSeconds) {
    const m = Math.floor(totalSeconds / 60);
    const s = totalSeconds % 60;
    return m + ':' + String(s).padStart(2, '0');
  }

  /** Refresh the record button label, status text and recording state. */
  function updateRecordUI() {
    if (!recordBtn)
      return;
    const icon = recordBtn.querySelector('.voice-mic-icon');
    const label = recordBtn.querySelector('.voice-record-label');
    if (recording) {
      icon.textContent = '⏹️';
      label.textContent = 'إيقاف التسجيل';
      recordBtn.classList.add('recording');
      recordStatus.textContent = 'جارٍ التسجيل… (' + formatRecordTime(recordSeconds) + ')';
    } else {
      icon.textContent = '🎤';
      label.textContent = audioBlob ? 'إعادة التسجيل' : 'تسجيل رسالة صوتية';
      recordBtn.classList.remove('recording');
      recordStatus.textContent = audioBlob ? 'تم تسجيل الرسالة الصوتية' : '';
    }
    const submitBtn = contactForm.querySelector('button[type="submit"]');
    if (submitBtn)
      submitBtn.disabled = recording;
  }

  /** Clear any recorded audio and reset the recorder UI. */
  function resetVoiceRecorder() {
    audioBlob = null;
    audioChunks = [];
    if (audioPreview) {
      audioPreview.removeAttribute('src');
      audioPreview.style.display = 'none';
    }
    updateRecordUI();
  }

  if (recordBtn) {
    recordBtn.addEventListener('click', async function () {
      if (recording) {
        mediaRecorder.stop();
        return;
      }
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        audioChunks = [];
        mediaRecorder = new MediaRecorder(stream);
        mediaRecorder.ondataavailable = (e) => { if (e.data.size > 0) audioChunks.push(e.data); };
        mediaRecorder.onstop = () => {
          recording = false;
          clearInterval(recordTimer);
          stream.getTracks().forEach(tr => tr.stop());
          if (audioChunks.length === 0) {
            recordStatus.textContent = 'تعذر الوصول إلى الميكروفون.';
            updateRecordUI();
            return;
          }
          audioBlob = new Blob(audioChunks, { type: mediaRecorder.mimeType || 'audio/webm' });
          audioPreview.src = URL.createObjectURL(audioBlob);
          audioPreview.style.display = '';
          updateRecordUI();
        };
        mediaRecorder.start(500);
        recording = true;
        recordSeconds = 0;
        updateRecordUI();
        recordTimer = setInterval(() => {
          recordSeconds++;
          if (recordSeconds >= MAX_RECORD_SECONDS) {
            mediaRecorder.stop();
          } else {
            updateRecordUI();
          }
        }, 1000);
      } catch (err) {
        recordStatus.textContent = 'تعذر الوصول إلى الميكروفون.';
      }
    });
  }
  contactForm.addEventListener('submit', async function (e) {
    e.preventDefault(); // Prevent form submission
    // Get form inputs
    const nameInput = document.getElementById('name');
    const emailInput = document.getElementById('email');
    const messageInput = document.getElementById('message');
    const captchaInput = document.getElementById('captchaInput');

    // Reset validation styles and messages
    document.querySelectorAll('.is-invalid').forEach(el => el.classList.remove('is-invalid'));
    document.getElementById('validationMessage').classList.add('d-none');

    // Block sending while a voice recording is still in progress
    if (recording) {
      document.getElementById('validationMessage').innerText = 'أوقف التسجيل الصوتي أولاً قبل تسجيل الرسالة.';
      document.getElementById('validationMessage').classList.remove('d-none');
      return;
    }

    // Validate Name Field
    if (!nameInput.value.trim()) {
      nameInput.classList.add('is-invalid');
      document.getElementById('validationMessage').innerText = 'الرجاء إدخال الاسم.';
      document.getElementById('validationMessage').classList.remove('d-none');
      return;
    }

    // Validate Email Field (if filled)
    if (emailInput.value.trim() && !utils.validateEmail(emailInput.value.trim())) {
      emailInput.classList.add('is-invalid');
      document.getElementById('validationMessage').innerText = 'البريد الإلكتروني غير صحيح.';
      document.getElementById('validationMessage').classList.remove('d-none');
      return;
    }

    // Validate Message Field (a recorded voice message can replace the text)
    if (!messageInput.value.trim() && !audioBlob) {
      messageInput.classList.add('is-invalid');
      document.getElementById('validationMessage').innerText = 'الرجاء إدخال الرسالة أو تسجيل رسالة صوتية.';
      document.getElementById('validationMessage').classList.remove('d-none');
      return;
    }

    // Validate CAPTCHA
    const convertedCaptchaInput = utils.convertArabicToEnglish(captchaInput.value.trim());
    console.log("convertedCaptchaInput = " + convertedCaptchaInput);
    console.log("captchaAnswer = " + captchaAnswer);
    console.log("convertedCaptchaInput = " + convertedCaptchaInput);
    let parsedCatcha = parseInt(convertedCaptchaInput, 10);
    if (parseInt(convertedCaptchaInput, 10) !== parseInt(captchaAnswer)) {
      captchaInput.classList.add('is-invalid');
      document.getElementById('validationMessage').innerText = 'CAPTCHA غير صحيح. يرجى المحاولة مرة أخرى.';
      document.getElementById('validationMessage').classList.remove('d-none');
      captchaAnswer = utils.generateCaptcha(); // Regenerate CAPTCHA
      captchaBox.innerHTML = captchaAnswer;
      return;
    }

    // Sanitize Inputs
    const sanitizedName = utils.sanitizeInput(nameInput.value.trim());
    const sanitizedEmail = utils.sanitizeInput(emailInput.value.trim());
    const sanitizedMessage = utils.sanitizeInput(messageInput.value.trim());

    // Log sanitized data (for demonstration purposes)

    // submitContact gathers every field, including the raw audio file.
    const data = {
      name: sanitizedName,
      email: sanitizedEmail,
      sessionId: config.sessionid,
      message: sanitizedMessage,
      audio: audioBlob
    };
    const result = await apihandler.submitContact(data);
    // Show Success Message
    // عرض رسالة النجاح مع الرابط والأيقونات
    if (result.success && result.data && result.data.success) {
      document.getElementById('validationMessage').innerHTML = `
    <i class="fas fa-check-circle"></i>
    تم إرسال الرسالة بنجاح! تتبع الرد على <a href="support.html">رسائل الدعم</a>
`;
      document.getElementById('validationMessage').classList.remove('d-none', 'alert-danger');
      document.getElementById('validationMessage').classList.add('alert-success');
    } else {

    }

    // Reset Form and CAPTCHA
    document.getElementById('contactForm').reset();
    resetVoiceRecorder();
    captchaAnswer = utils.generateCaptcha();
  });
}
function fireMessageDetailsPageEvents() {
  const urlParams = new URLSearchParams(window.location.search);
  const messageId = urlParams.get('messageId');
  if (!messageId)
    return;
  const sessionid = config.sessionid;
  if (sessionid && messageId) {
    apihandler.fetchReplies(sessionid, messageId)
      .then(data => {
        ui.displayReplies(data.replies)
        ui.hideLoaderContainer();
      })
      .catch(error => console.error('Error:', error));

  } else {
    console.error('sid and msgId are required');
  }
  // Attach form submission handler
  document.getElementById('reply-form').addEventListener('submit', (e) => {
    handleReplyFormSubmit(e, messageId);

  });
}
/**
 * 
 * @param {event} event 
 * @param {string} messageId 
 * @returns 
 */
async function handleReplyFormSubmit(event, messageId) {
  event.preventDefault();
  if (!document.getElementById('reply-message'))
    return;
  const replyMessage = document.getElementById('reply-message').value;
  const sanitizedMessage = utils.sanitizeInput(replyMessage.trim());
  if (!sanitizedMessage.trim()) {
    //alert('Please enter a reply message.');
    return;
  }
  let data = {
    "msgId": messageId,
    "sessionId": config.sessionid,
    "message": sanitizedMessage
  }
  const result = await apihandler.submitContact(data);
  // Send the reply (you can implement this part)
  if (result.data) {
    document.getElementById('validationMessage').innerHTML = `
            <i class="fas fa-check-circle"></i> تم إرسال الرسالة بنجاح! `;
    document.getElementById('validationMessage').classList.remove('d-none', 'alert-danger');
    document.getElementById('validationMessage').classList.add('alert-success');
    document.getElementById('reply-form').reset();
  } else {
    //  document.getElementById('validationMessage').innerHTML = `
    //         <i class="fas fa-check-circle"></i> تم إرسال الرسالة بنجاح! `;
    //   document.getElementById('validationMessage').classList.add('alert-success');

  }

}
async function fireImageHistoryLoadEvent() {
  //document.addEventListener("load", function () {
  ui.hideLoaderContainer();
  let controls = document.querySelectorAll('.container-controls'); // Select all elements
  controls.forEach(control => {
    control.style.visibility = 'visible'; // Show each element
  });
  let boxImage = document.querySelector('.box-image');
  if (boxImage) {
    boxImage.style = "display:block;";
  }
  //});
}
async function fireDeleteConfirmationEvent() {
  document.getElementById("confirmDeleteBtn").addEventListener("click", function () {

    if (config.currentIndexToDelete != null) {
      let removedItem = utils.getStoredDesigns(config.historyKey)[config.currentIndexToDelete];
      utils.removeDesignObject(config.historyKey, config.currentIndexToDelete);
      if (removedItem) {
        canvasRender.removeStoredImage(removedItem.imageName);
      }
      let items = utils.sanitizeImages(config.currentIndexToDelete);
      document.getElementById(`design_${config.currentIndexToDelete}`).remove();
      if (items.length == 0) {
        historyContainer.innerHTML = ui.displayEmptyStorageMessage();
      }
      if (config.images.length != 0) {
        // delete image from array if it exists
        config.images.splice(config.images.indexOf(items[config.currentIndexToDelete].imagepath), 1);
      }
      let deleteModal = bootstrap.Modal.getInstance(document.getElementById("deleteModal"));
      deleteModal.hide();
    }
  });

}
// show ads in download page

export async function showAdsInDownloadPage() {
  if (settingData.pagetype == "download") {
    if (settingData.general.forceShare) {
      if (config.isUserNotApplicable) {
        // show ads
        (adsbygoogle = window.adsbygoogle || []).push({});
      } else {
        var key = 'fb-' + config.designName;
        if (utils.getLocalStorageValue(key)) {
          (adsbygoogle = window.adsbygoogle || []).push({});
        }
      }
    } else {
      (adsbygoogle = window.adsbygoogle || []).push({});
    }
  }
}
export async function navigateToStepsDetails() {
  document.querySelectorAll('[data-scroll]').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const target = document.getElementById('steps-title');
      if (!target) return;

      // ────────────────────────────────────────────────
      //          Custom slow scroll (most control)
      // ────────────────────────────────────────────────
      const start = window.scrollY;
      const end = target.getBoundingClientRect().top + start - 200; // 20px offset
      const distance = end - start;
      const duration = 1800; // ← change this value (ms) — 1800–3000 feels "slow"

      let startTime = null;

      function animateScroll(timestamp) {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Ease-in-out (very smooth & slow feeling)
        const ease = progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        window.scrollTo(0, start + distance * ease);

        if (elapsed < duration) {
          requestAnimationFrame(animateScroll);
        }
      }

      requestAnimationFrame(animateScroll);

      // Highlight
      target.classList.add('highlight-step');
      setTimeout(() => {
        target.classList.remove('highlight-step');
      }, 2000);
    });
  });
}
// back to top event
export async function fireBackToTopEvent() {
  const backToTop = document.getElementById('back-to-top');
  if (!backToTop)
    return;
  window.addEventListener('scroll', () => {
    if (window.scrollY > 1100) { // يظهر بعد النزول 300px
      backToTop.style.display = 'flex';
    } else {
      backToTop.style.display = 'none';
    }
  });


  backToTop.addEventListener('click', () => {
    const startY = window.scrollY;
    const duration = 600; // مدة الصعود 1 ثانية
    let startTime = null;

    function scrollUp(currentTime) {
      if (!startTime) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 3); // easeOutCubic
      window.scrollTo(0, startY * (1 - ease));

      if (timeElapsed < duration) {
        requestAnimationFrame(scrollUp);
      }
    }

    requestAnimationFrame(scrollUp);
  });
}